import { cn } from "@/lib/utils";
import type { HTMLAttributes } from "react";

export function DataGrid({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("app-data-grid", className)} {...props} />;
}

export function DataGridHeader({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("app-data-grid-header", className)} {...props} />;
}

export function DataGridRow({
  className,
  interactive = true,
  ...props
}: HTMLAttributes<HTMLDivElement> & { interactive?: boolean }) {
  return (
    <div
      className={cn(
        "app-data-grid-row",
        !interactive && "app-data-grid-row--static",
        className,
      )}
      {...props}
    />
  );
}

export function DataGridLabel({
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement>) {
  return <span className={cn("app-data-grid-label", className)} {...props} />;
}

export function DataGridCell({
  className,
  variant = "body",
  ...props
}: HTMLAttributes<HTMLSpanElement> & { variant?: "body" | "meta" | "mono" }) {
  return (
    <span
      className={cn(
        "app-data-grid-cell",
        `app-data-grid-cell--${variant}`,
        className,
      )}
      {...props}
    />
  );
}

export function DataGridEmpty({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("app-data-grid-empty", className)} {...props} />;
}
